// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__zo7M0","label":"Input_label__z-LP7","base":"Input_base__3yn8e","input":"Input_input__3PNbO"};